import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { BiData, BuyCoreButtonBiEvent } from '@wix/da-bi/pkg/events';
import BuyCoreTextButton from '@wix/da-shared-react/pkg/Button/core/dsPresets/BuyCoreTextButton';
import CoreSymbol from '@wix/da-ds/pkg/Indicators/CoreSymbol';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import FieldsGroup from '../../layouts/common/FieldsGroup';
import TierSelectField from '../TierSelectField';
import SellExclusiveField from '../SellExclusiveField';
import PremiumGalleryField from '../PremiumGalleryField';
import PcpFieldsWrapper from '../PcpFieldsWrapper';
import UpgradeTooltip from './_partials/UpgradeTooltip';

interface Props {}

const SellFieldsGroup: React.FC<Props> = () => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const { hasCoreMembership } = useContext(SessionContext);

  const coreIcon = <CoreSymbol size={IconSize.SMALL} />;
  const upgradeBtn = !hasCoreMembership && (
    <BuyCoreTextButton
      biData={BiData<BuyCoreButtonBiEvent>({
        evid: 375,
        referral_info: ReferralType.SUBMIT_SELL_SECTION,
      })}
      size="medium"
      noHorizontalPaddings
    >
      {t('deviationSubmit.form.section.sell.title.upgrade')}
    </BuyCoreTextButton>
  );

  return (
    <FieldsGroup
      title={
        <>
          {t('deviationSubmit.form.section.sell.title')}
          {isMobile && !hasCoreMembership ? (
            <UpgradeTooltip>{coreIcon}</UpgradeTooltip>
          ) : (
            coreIcon
          )}
        </>
      }
      titleRight={
        upgradeBtn && !isMobile ? (
          <UpgradeTooltip>{upgradeBtn}</UpgradeTooltip>
        ) : (
          upgradeBtn
        )
      }
    >
      <SellExclusiveField />
      <PcpFieldsWrapper />
      <TierSelectField />
      <PremiumGalleryField />
    </FieldsGroup>
  );
};
SellFieldsGroup.displayName = 'SellFieldsGroup';

export default SellFieldsGroup;
